<template>
    <rkm-layout-body title="Lista de material">
        <template v-slot:actions>
            <rkm-button
                @click="openCadastroMaterialConectaSus"
                authorize="store-cadastro-material"
                color="primary"
            >
                Cadastrar material (ConectaSUS)
            </rkm-button>

            <rkm-button
                @click="$router.push({name: 'web-service-almoxarifado-cliente-material-create'})"
                authorize="store-web-service-almoxarifado-cliente-material"
                color="primary"
            >
                Cadastrar material
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/almoxarifado/cliente/material/List'

export default {
    components: {List},
    methods: {
        openCadastroMaterialConectaSus() {
            window.open(this.$router.resolve({name: 'cadastro-material-create'}).href, '_blank')
        },
    },
}
</script>